/* eslint-disable */
const prefix = '/api/auth';

export default {
    state: {
        user: {},
        accessToken: '',
    },
    mutations: {
        setAccessToken(state, payload) {
            state.accessToken = payload;
            localStorage.setItem('vue-authenticate.vueauth_token', payload);
        },
        setUser(state, payload) {
            state.user = payload;
        },
    },
    actions: {
        register(context, payload) {
            const url = `${prefix}/register`;
            return new Promise((resolve, reject) => {
                this._vm.$apiClient.post(url, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            this._vm.$apiClient.accessToken.set(response.data.access_token);
                            this.commit('setAccessToken', response.data.access_token);
                            resolve(response);
                        } else {
                            reject(response.errors);
                        }
                    })
            });
        },
        login(context, payload) {
            const url = `${prefix}/login`;
            return new Promise((resolve, reject) => {
                this._vm.$apiClient.post(url, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            this._vm.$apiClient.accessToken.set(response.data.access_token);
                            this.commit('setAccessToken', response.data.access_token);
                            resolve(response);
                        } else {
                            reject(response.errors);
                        }
                    });
            });
        },
        logout() {
            this._vm.$apiClient.accessToken.clear();
            this._vm.$session.clear();
            this.commit('setAccessToken', '');
            this.commit('setUser', {});
        },
        getSelf() {
            const url = `${prefix}/me`;
            return this._vm.$apiClient.get(url).then((response) => {
                this.commit('setUser', response.data);
                return response;
            });
        },
        refreshToken() {
            const url = `${prefix}/refresh`;
            return this._vm.$apiClient.get(url).then((response) => {
                this._vm.$apiClient.accessToken.set(response.data.access_token);
                this.commit('setAccessToken', response.data.access_token);
                return response;
            });
        },
        forgotPassword(context, payload) {
            const url = `/api/password/email`;
            return this._vm.$apiClient.post(url, payload).then((response) => {
                this._vm.$apiClient.accessToken.set(response.data.access_token);
                this.commit('setAccessToken', response.data.access_token);
                return response;
            });
        },
        passwordReset({ commit, dispatch }, payload) {
            const url = `/api/password/reset`;
            return new Promise((resolve, reject) => {
                this._vm.$apiClient.post(url, payload)
                    .then((response) => {
                        if (response.status === 200) {
                            this._vm.$apiClient.accessToken.set(response.data.access_token);
                            this.commit('setAccessToken', response.data.access_token);
                            dispatch('logout');
                            resolve(response);
                        } else {
                            reject(response.errors);
                        }
                });
            });

        },
        verifyEmail({ commit, dispatch }, payload) {
            const url = `/api/email/verify`;
            return this._vm.$apiClient.post(url, payload).then((response) => {
                return response;
            });
        },

    },
    getters: {},
}
